// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + ' verschoben.',
  accButtonProgressComplete: (p: { label: string }) => p['label'] + '-Aktion abgeschlossen',
  accButtonProgressStatus: (p: { label: string }) => p['label'] + '-Aktion wird ausgeführt',
  accColorPalette: () => 'Farbpalette',
  accColorSwatch: () => 'Farbmuster',
  accCommandKey: () => 'Befehl',
  accContextMenuLabel: () => 'Aktionen',
  accControlKey: () => 'Schließen',
  accPositionAfter: () => 'nach',
  accPositionBefore: () => 'vor',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Halten Sie ' +
    p['keyPressed'] +
    ' und die Umschalttaste gedrückt, und ändern Sie die Reihenfolge mit den Pfeiltasten.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Geben Sie ein vollständiges Datum wie folgt ein: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Geben Sie einen Monat und ein Jahr wie folgt ein: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Label',
  chart_labelGroup: () => 'Gruppe',
  chart_labelSeries: () => 'Reihe',
  chart_labelValue: () => 'Wert',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Wählen Sie einen Wert aus.',
  checkbox_helpForCheckbox: () => 'Hilfe für Kontrollkästchen',
  checkbox_requiredMessageDetail: () => 'Wählen Sie einen Wert aus.',
  checkbox_selected: () => 'Kontrollkästchen aktiviert',
  checkbox_unselected: () => 'Kontrollkästchen nicht aktiviert',
  close: () => 'Schließen',
  collection_apply: () => 'Anwenden',
  collection_cancel: () => 'Abbrechen',
  collection_loaded: () => 'Geladen',
  collection_loading: () => 'Wird geladen',
  collection_noData: () => 'Keine anzuzeigenden Daten.',
  collection_pixels: () => 'Pixel',
  collection_resizeColumnDialog: () => 'Spalte skalieren',
  collection_resizeColumnMenu: () => 'Spalte skalieren...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Geben Sie eine Zahl zwischen ' + p['MIN'] + ' und ' + p['MAX'] + ' ein.',
  collection_selectAllRows: () => 'Alle Zeilen auswählen',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Zeile ' + p['ROW_NAME'] + ' auswählen',
  collection_sortAscendingSubMenu: () => 'Aufsteigend',
  collection_sortColumnMenu: () => 'Spalte sortieren',
  collection_sortDescendingSubMenu: () => 'Absteigend',
  collection_sortDisabled: () => 'Nicht sortierbar',
  collection_sortEnabled: () => 'Sortierbar',
  collection_width: () => 'Breite',
  colorPicker_label: () => 'Farbauswahl',
  confirmation: () => 'Bestätigung',
  datePicker_currentDate: () => 'Aktuelles Datum',
  datePicker_goToToday: () => 'Heute',
  datePicker_label: () => 'Datumsauswahl',
  datePicker_month: () => 'Monat',
  datePicker_months: () => 'Monate',
  datePicker_next: () => 'Nächste',
  datePicker_nextDecade: () => 'Nächstes Jahrzehnt',
  datePicker_nextMonth: () => 'Nächster Monat',
  datePicker_prev: () => 'Vorherige',
  datePicker_prevDecade: () => 'Vorheriges Jahrzehnt',
  datePicker_prevMonth: () => 'Vorheriger Monat',
  datePicker_restricted: () => 'Eingeschränkt',
  datePicker_selected: () => 'Ausgewählt',
  datePicker_today: () => 'Heute',
  datePicker_weekNum: (p: { NUM: string }) => 'Woche ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Wochennummer',
  datePicker_year: () => 'Jahr',
  datePicker_years: () => 'Jahre',
  diagram_promotedLink: () => '1 Link',
  diagram_promotedLinkAriaDesc: () => 'Indirekt',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' Links',
  error: () => 'Fehler',
  expandableList_expandCollapseInstructionText: () =>
    'Pfeiltasten zum Ein- und Ausblenden verwenden',
  expandableList_groupCollapse: () => 'Ausgeblendet',
  expandableList_groupExpand: () => 'Eingeblendet',
  filePicker_addFiles: () => 'Dateien hinzufügen',
  filePicker_dropzonePrimaryText: () => 'Drag-and-Drop',
  filePicker_dropzoneSecondaryText: () => 'Datei auswählen oder hier ablegen',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Dateien auswählen oder hier ablegen',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Sie können keine Dateien des folgenden Typs hochladen: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Laden Sie jeweils nur eine Datei hoch',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Sie können keine Dateien des Typs ' + p['fileType'] + ' hochladen',
  filePicker_unknownFileTypeUploadError: () => 'unbekannt',
  formControl_clear: () => 'Leeren',
  formControl_day: () => 'Tag',
  formControl_empty_segment: () => 'Leer',
  formControl_helpAvailable: () => 'Hilfe verfügbar',
  formControl_hide: () => 'Verbergen',
  formControl_hour: () => 'Stunde',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Sie haben den Grenzwert von ' +
    ((
      { one: new Intl.NumberFormat('de').format(p['CHARACTER_LIMIT']) + ' Zeichen' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('de').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('de').format(p['CHARACTER_LIMIT']) + ' Zeichen') +
    ' erreicht.',
  formControl_loading: () => 'Wird geladen',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Sie können bis zu ' + p['MAX_LENGTH'] + ' Zeichen eingeben.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximale Länge ' + p['MAX_LENGTH'] + ' überschritten.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' Zeichen übrig.',
  formControl_millisecond: () => 'Millisekunde',
  formControl_minute: () => 'Minute',
  formControl_month: () => 'Monat',
  formControl_readOnly: () => 'Schreibgeschützt',
  formControl_requiredMessageDetail: () => 'Geben Sie einen Wert ein.',
  formControl_second: () => 'Sekunde',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Wählen Sie ' + p['n'] + ' Werte aus.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Sie haben den Auswahlgrenzwert von ' + p['max'] + ' erreicht.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Wählen Sie ' + p['min'] + ' bis ' + p['max'] + ' Werte aus.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Wählen Sie mindestens ' + p['min'] + ' Werte aus.',
  formControl_show: () => 'Anzeigen',
  formControl_year: () => 'Jahr',
  gantt_labelDate: () => 'Datum',
  gantt_labelEnd: () => 'Ende',
  gantt_labelLabel: () => 'Label',
  gantt_labelRow: () => 'Zeile',
  gantt_labelStart: () => 'Start',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Kein übereinstimmender Abschnitt gefunden.',
  indexer_keyboardInstructionText: () => 'Drücken Sie die Eingabetaste, um einen Wert auszuwählen.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Zwischen ' + p['FROM_SECTION'] + ' und ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Doppeltippen und halten, um den Gestenmodus aufzurufen, und anschließend nach oben oder unten ziehen, um den Wert anzupassen.',
  info: () => 'Info',
  inputColor_selectColor: () => 'Wählen Sie eine Farbe aus',
  inputDateMask_date_cleared: () => 'Datum gelöscht',
  inputDateMask_dayPlaceholder: () => 'TT',
  inputDateMask_empty_segment: () => 'Leer',
  inputDateMask_monthPlaceholder: () => 'MM',
  inputDateMask_yearPlaceholder: () => 'JJJJ',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Geben Sie ein Datum ein, das ' + p['max'] + ' entspricht oder davor liegt.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Geben Sie ein Datum ein, das ' + p['min'] + ' entspricht oder danach liegt.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Geben Sie ein verfügbares Datum ein.',
  inputDatePicker_instruction: () =>
    'Drücken Sie die Tabulatortaste, um auf den Kalender zuzugreifen.',
  inputDatePicker_selectDate: () => 'Datum auswählen',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Geben Sie einen Monat und ein Jahr am oder vor ' + p['max'] + ' ein.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Geben Sie einen Monat und ein Jahr am oder nach ' + p['min'] + ' ein.',
  inputNumber_converterParseError: () => 'Geben Sie eine Zahl ein.',
  inputNumber_decrease: () => 'Verringern',
  inputNumber_increase: () => 'Erhöhen',
  inputPassword_hidden: () => 'Kennwort ausgeblendet',
  inputPassword_hide: () => 'Kennwort ausblenden',
  inputPassword_show: () => 'Kennwort anzeigen',
  inputSensitiveText_hidden: () => 'Sensibler Text ausgeblendet',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Geben Sie eine Uhrzeit ein, die ' + p['max'] + ' entspricht oder davor liegt.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Geben Sie eine Uhrzeit ein, die ' + p['min'] + ' entspricht oder danach liegt.',
  inputTimeMask_time_cleared: () => 'Gelöscht um',
  labelNone: () => 'Kein Wert',
  list_msgFetchCompleted: () => 'Geladen',
  list_msgFetchingData: () => 'Wird geladen',
  list_suggestion: () => 'Vorschlag',
  menu_stateLoading: () => 'Wird geladen',
  messageToast_allMessagesClosed: () => 'Alle Popup-Nachrichten sind geschlossen.',
  message_close: () => 'Schließen',
  message_confirmation: () => 'Erfolg',
  message_error: () => 'Fehler',
  message_info: () => 'Info',
  message_navigationFromMessagesRegion: () =>
    'Meldungsbereich wird geöffnet. Drücken Sie F6 zum Navigieren.',
  message_navigationToMessagesRegion: () =>
    'Region "Meldungen" enthält neue Meldungen. Drücken Sie F6 zum Navigieren.',
  message_navigationToTouch: () => 'Region "Meldungen" enthält neue Meldungen.',
  message_warning: () => 'Warnung',
  noData_message: () => 'Keine anzuzeigenden Elemente',
  overflowItemLabel: () => 'Weitere Registerkarten',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Doppeltippen Sie, um das geöffnete Popup zu schließen.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Popup wird aufgerufen. Drücken Sie F6, um zwischen dem Popup und dem zugehörigen Steuerelement zu navigieren.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Popup geöffnet. Drücken Sie F6, um zwischen dem Popup und dem zugehörigen Steuerelement zu navigieren.',
  progressIndeterminate: () => 'Wird ausgeführt',
  radioButton_checked: () => 'Optionsfeld aktiviert',
  radioButton_selected: () => 'Optionsfeld aktiviert',
  radioButton_unchecked: () => 'Optionsfeld nicht aktiviert',
  radioButton_unselected: () => 'Optionsfeld nicht aktiviert',
  radio_helpForRadio: () => 'Hilfe für Optionsfeld',
  radio_requiredMessageDetail: () => 'Wählen Sie einen Wert aus.',
  selectMultiple_apply: () => 'Anwenden',
  selectMultiple_back: () => 'Zurück',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Verwenden Sie die Pfeiltasten nach links und rechts, um ausgewählte Werte hervorzuheben.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Drücken Sie die Rücktaste oder ENTF, um den ausgewählten Wert zu entfernen.',
  selectMultiple_selectedValues: () => 'Ausgewählte Werte',
  selectMultiple_showSelectedValues: () => 'Nur ausgewählte Werte anzeigen.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' Werte ausgewählt.',
  select_addToList: () => 'Zu Liste hinzufügen',
  select_addToListAvailable: () => '"Zu Liste hinzufügen" verfügbar',
  select_closeDropdown: () => 'Drücken Sie zum Schließen die Esc-Taste.',
  select_moreSearchOptions: () => 'Weitere Suchoptionen',
  select_moreSearchOptionsAvailable: () => 'Weitere Suchoptionen verfügbar',
  select_noMatchesFound: () => 'Keine Übereinstimmungen gefunden.',
  select_oneMatchFound: () => 'Eine Übereinstimmung gefunden',
  select_requiredMessageDetail: () => 'Wählen Sie einen Wert aus.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' Übereinstimmungen gefunden',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' oder mehr Übereinstimmungen gefunden',
  selectorAll_deselectAll: () => 'Gesamte Auswahl aufheben',
  selectorAll_selectAll: () => 'Alle auswählen',
  selector_selected: () => 'Kontrollkästchen aktiviert',
  selector_unselected: () => 'Kontrollkästchen nicht aktiviert',
  sheet_close: () => 'Schließen',
  switch_off: () => 'Aus',
  switch_on: () => 'Ein',
  tabBarNavigationList_removeCueText: () => 'Kann entfernt werden',
  tabBar_tabContainsErrors: () => 'Enthält Fehler',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => p['itemKey'] + ' entfernt',
  tabbar_labelContextMenu: () => 'hat Kontextmenü',
  tabbar_labelMoveLeft: () => 'Nach links verschieben',
  tabbar_labelMoveRight: () => 'Nach rechts verschieben',
  tabbar_labelRemove: () => 'Entfernen',
  timeComponent_tooltipZoomIn: () => 'Vergrößern',
  timeComponent_tooltipZoomOut: () => 'Verkleinern',
  timeConverter_parseError: () => 'Geben Sie eine vollständige Zeit ein.',
  train_current: () => 'Aktuell',
  train_message_type: () => 'Meldungstyp',
  train_not_visited: () => 'Nicht besucht',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Schritt ' + p['currentStep'] + ' von ' + p['numberOfSteps'],
  train_visited: () => 'Besucht',
  userAssistance_learnMore: () => 'Weitere Informationen',
  userAssistance_required: () => 'Erforderlich',
  vis_clearSelection: () => 'Auswahl löschen',
  vis_drillable: () => 'Drillfähig',
  vis_invalidData: () => 'Ungültige Daten',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' von ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Auswahlbereich',
  vis_marqueeZoomTooltip: () => 'Auswahlzoom',
  vis_noData: () => 'Keine anzuzeigenden Daten',
  vis_panTooltip: () => 'Schwenken',
  vis_stateCollapsed: () => 'Ausgeblendet',
  vis_stateExpanded: () => 'Eingeblendet',
  vis_stateLoaded: () => 'Geladen',
  vis_stateLoading: () => 'Wird geladen',
  vis_stateSelected: () => 'Ausgewählt',
  vis_stateUnselected: () => 'Auswahl aufgehoben',
  warn: () => 'Warnung'
};
export default bundle;
